// extracted by mini-css-extract-plugin
export default {"Modal":"InvoiceChangeInvoiceStatusModal_Modal__bmLv2","Options":"InvoiceChangeInvoiceStatusModal_Options__c4lbj"};